import CourseDetailsPage from './CourseDetailsPage';
import { CourseDetailsPageProps, CourseDetailsPageValueProps } from './types';

export type { CourseDetailsPageProps, CourseDetailsPageValueProps };
export default CourseDetailsPage;
